import React from "react";

const Button = ({ children, onClick, variant = "default", className = "" }) => {
  const baseStyles = "px-4 py-2 rounded-md font-medium transition-all";
  const variantStyles = {
    // default: "bg-gray-500 text-white hover:bg-gray-600",
    default: "bg-[#c97c5d] text-white hover:bg-orange-700",
    primary: "bg-blue-500 text-white hover:bg-blue-600",
    secondary: "bg-gray-300 text-gray-700 hover:bg-gray-400",
    danger: "bg-red-700 text-white hover:bg-red-600",
    black: "bg-black text-white hover:bg-red-600",
    red:"bg-red-700 text-white hover:bg-black"
    
  };

  return (
    <button
      className={`${baseStyles} ${variantStyles[variant] || variantStyles.default} ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
